const CONSENT_STORAGE_KEY = "iyalagi-analytics-consent";
let lastPageView = { key: "", time: 0 };

export function pushDataLayer(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

export function trackSpaPageView() {
  const pageKey = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const now = Date.now();

  if (lastPageView.key === pageKey && now - lastPageView.time < 1_000) {
    return;
  }

  lastPageView = { key: pageKey, time: now };
  pushDataLayer({
    event: "spa_page_view",
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function getAnalyticsConsent() {
  return window.localStorage.getItem(CONSENT_STORAGE_KEY);
}

export function updateAnalyticsConsent(choice) {
  const analyticsStorage = choice === "granted" ? "granted" : "denied";

  window.gtag?.("consent", "update", {
    analytics_storage: analyticsStorage,
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  window.localStorage.setItem(CONSENT_STORAGE_KEY, choice);
}